import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum SelfieStatus {
  Initiated = 'initiated',
  Submitted = 'submitted',
  Processed = 'processed',
  Errored = 'errored',
}

export interface SelfieBaseAttributes {
  // TODO: Migrate this to SelfieStatus enum
  status: string;
  'created-at': string;
  'submitted-at': string;
  'processed-at': string;
  'redacted-at'?: string;
}

export enum RegistryRegistrationStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
}
export interface RegistryRegistrationData {
  // May be nil if the selfie was not processed
  status?: RegistryRegistrationStatus;
  'error-message': string;
}

export interface SelfieCenterOnlyAttributes extends SelfieBaseAttributes {
  'photo-url': string;
  'registry-registration-data': RegistryRegistrationData;
}
export interface SelfieProfileAndCenterAttributes extends SelfieBaseAttributes {
  'left-photo-url': string;
  // TODO - deprecate and use url in center-photo instead
  'center-photo-url': string;
  'right-photo-url': string;
  'center-photo': {
    url: string;
    'registry-registration-data': RegistryRegistrationData;
  };
}

export interface SelfieRelationships {
  inquiry: ApiRelationship<ApiModel.Inquiry>;
}

export type SelfieCenterOnly = ApiResource<
  SelfieCenterOnlyAttributes,
  SelfieRelationships,
  ApiModel.SelfieCenterOnly
>;

export type SelfieProfileAndCenter = ApiResource<
  SelfieProfileAndCenterAttributes,
  SelfieRelationships,
  ApiModel.SelfieProfileAndCenter
>;

export type Selfie = SelfieCenterOnly | SelfieProfileAndCenter;
